import { useState } from 'react';
import styles from './Accordion.module.css';

type AccordionProps = {
    header: React.ReactNode;
    children: React.ReactNode;
    isOpen?: boolean;
    onToggle?: () => void;
    className?: string;
};

export const Accordion = ({ header, children, isOpen: controlledIsOpen, onToggle, className = '' }: AccordionProps) => {
    const [internalIsOpen, setInternalIsOpen] = useState(false);

    // Use controlled state if provided, otherwise use internal state
    const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;
    const handleToggle = () => {
        if (onToggle) {
            onToggle();
        } else {
            setInternalIsOpen(!internalIsOpen);
        }
    };

    return (
        <div className={`${styles.accordion} ${className}`}>
            <div className={styles.accordionHeader}>
                {header}
                <button className={`${styles.toggleButton} ${isOpen ? styles.open : ''}`} onClick={handleToggle} />
            </div>
            {isOpen && <div className={styles.accordionBody}>{children}</div>}
        </div>
    );
};
